import gmailSrc from '@corbado/shared-ui/assets/gmail.svg';
import React from 'react';
import { Icon } from './Icon';
export const GmailIcon = props => {
    return (React.createElement(Icon, { src: gmailSrc, ...props }));
};
